export const TermsOfServices = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.30005 6C5.30005 5.6134 5.61345 5.3 6.00005 5.3H10C10.3866 5.3 10.7 5.6134 10.7 6C10.7 6.3866 10.3866 6.7 10 6.7H6.00005C5.61345 6.7 5.30005 6.3866 5.30005 6Z"
        fill="#706A85"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.30005 8C5.30005 7.6134 5.61345 7.3 6.00005 7.3H10C10.3866 7.3 10.7 7.6134 10.7 8C10.7 8.3866 10.3866 8.7 10 8.7H6.00005C5.61345 8.7 5.30005 8.3866 5.30005 8Z"
        fill="#706A85"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.30005 10C5.30005 9.6134 5.61345 9.3 6.00005 9.3H8.00005C8.38665 9.3 8.70005 9.6134 8.70005 10C8.70005 10.3866 8.38665 10.7 8.00005 10.7H6.00005C5.61345 10.7 5.30005 10.3866 5.30005 10Z"
        fill="#706A85"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.20005 3.2V12.8H9.7101L12.8 9.71005V3.2H3.20005ZM2.15152 2.15148C2.37656 1.92643 2.68179 1.8 3.00005 1.8H13C13.3183 1.8 13.6235 1.92643 13.8486 2.15148C14.0736 2.37652 14.2 2.68174 14.2 3V9.79313C14.1999 10.111 14.0737 10.4161 13.849 10.641L10.6413 13.8487C10.4164 14.0733 10.1113 14.1999 9.7935 14.2H3.00005C2.68179 14.2 2.37657 14.0736 2.15152 13.8485C1.92648 13.6235 1.80005 13.3183 1.80005 13V3C1.80005 2.68174 1.92648 2.37652 2.15152 2.15148Z"
        fill="#706A85"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.30005 9.99938C9.30005 9.61278 9.61345 9.29938 10 9.29938H13.455C13.8416 9.29938 14.155 9.61278 14.155 9.99938C14.155 10.386 13.8416 10.6994 13.455 10.6994H10.7V13.4544C10.7 13.841 10.3866 14.1544 10 14.1544C9.61345 14.1544 9.30005 13.841 9.30005 13.4544V9.99938Z"
        fill="#706A85"
      />
    </svg>
  );
};
